import { Component, Injector, OnInit } from '@angular/core';

import { AppConfiguration } from '../../../bootstrap/climatecare/app.configuration';
import { FeatureComponent } from '../feature-component-registry/feature-component.interface';

@Component({
  selector: 'app-icroa-footer',
  templateUrl: './icroa-footer.component.html',
  styleUrls: [ '../../../../assets/css/climatecare/app.css', './icroa-footer.component.css' ]
})
export class IcroaFooterComponent implements OnInit, FeatureComponent {

  data: any;

  termsAndConditionsLink = 'https://www.climateimpact.com/business-solutions/carbon-credits-explained-what-they-are-and-how-they-work/carbon-footprint-calculator/carbon-calculator-terms-and-conditions/?language=en-gb ';
  methodologyLink = 'https://www.climateimpact.com/business-solutions/carbon-credits-explained-what-they-are-and-how-they-work/carbon-footprint-calculator/calculator-methodology/?language=en-gb  ';

  logoClass = 'icroa-rev';

  constructor(private injector: Injector) {
    const appConfiguration: AppConfiguration = this.injector.get(AppConfiguration);
    const tcLink =
      appConfiguration.clientConfiguration.clientSettings.termsAndConditionsLink;

    if (appConfiguration.clientConfiguration.clientSettings.footerLogoClass) {
      this.logoClass = appConfiguration.clientConfiguration.clientSettings.footerLogoClass;
    }

    if (tcLink) {
      this.termsAndConditionsLink = tcLink;
    }
  }

  ngOnInit(): void {}

}
